<template>
  <div class="main-page page-yasf">
    <Menu
      :title="title"
      :home="true"
    />
    <div
      class="main-block"
      v-if="isloadend"
    >
      <div class="left-nav">
        <div
          @click="setType(navitem)"
          :class="['item','txtone',navitem.id==current?'active':'']"
          v-for="(navitem ,index) in leftypelist"
          :key="'key-nav'+index"
        >
          {{navitem.title}}
        </div>
      </div>
      <div class="right-con">
        <div class="list-box">
          <template v-if="list.length">
            <div class="list-title">
              {{currentitle}} > 全部
            </div>
            <div
              class="item"
              v-for="(item,index) in list"
              @click="getDetail(item.id)"
              :key="'key-d'+index"
            >
              <div class="imgs">
                <img
                  src="/img/ui/yasfcase.png"
                  width="43"
                  alt=""
                >
                <!-- 如果案例是视频就用此图 -->
                <!-- <img
                  src="/img/ui/yasfvideo.png"
                  width="46"
                  alt=""
                > -->
              </div>
              <div class="intro ">
                <div class="title txtone">
                  {{item.title}}
                </div>
                <div class="desc">
                  {{currentitle}}
                  <span>
                    •
                  </span>
                  <template v-if="item.viewCount"> {{item.viewCount}} </template> <template v-else>0 </template> 次浏览
                </div>
              </div>
            </div>
          </template>
          <template v-if="!list.length">
            <div class="emptyinfo"><img
                src="/img/ui/emptyinfo1.png"
                alt=""
              >
              <p>暂无</p>
            </div>
          </template>
        </div>
        <div class="hotlist">
          <div class="prevtitle">
            大家都在看
          </div>
          <template v-if="hotlist.length">
            <div
              class="newsitem"
              @click="getDetail(news.id)"
              v-for="(news,index) in hotlist"
              :key="'key--'+index"
            >
              <div class="num">
                {{(index+1)}}
              </div>
              <div class="newstitle txtetc">
                {{news.title}}
              </div>
            </div>
          </template>
          <p v-else> 暂无</p>
        </div>
      </div>
    </div>
    <Rightslide
      v-model="slide"
      v-if="slide.show"
      @getClose="getClose"
    >
      <template slot="content">
        <div class="title">
          {{detail.title}}
        </div>
        <div
          class="detail"
          v-html="detail.htmlContent"
        >
        </div>
        <div class="source">
          <p>文章转载自 "{{detail.entryname}}"微信公众号,&nbsp; 如有侵权请联系删除</p>
        </div>
      </template>
    </Rightslide>
  </div>
</template>
<script>
import Menu from '../components/Menu'
import Rightslide from '../components/RightSlide'
import api from '../datas/js/api.js'
import { YASF_INQUIRE } from '../datas/constants/statistics.js'
export default {
  components: {
    Menu,
    Rightslide
  },
  data () {
    return {
      title: '以案释法',
      slide: {
        show: false
      },
      current: 1,
      currentitle: '',
      leftypelist: [],
      list: [],
      detail: '',
      hotlist: [],
      isloadend: false
    }
  },
  computed: {
    appInfo () {
      return this.$store.getters['app/getAppInfo']
    }
  },
  async created () {
    if (!this.appInfo.appId) {
      await this.$store.dispatch('app/getAppInfoBySite')
    }
    const { categoryId, title } = this.$route.query
    const res = await this.$get(`${api.doc.types}?appId=${this.appInfo.appId}&type=5`)
    if (!res.response.success) {
      console.log(res.response.msg)
      return
    }
    if (res.data) {
      this.leftypelist = res.data
      if (categoryId && title) {
        this.current = categoryId
        this.currentitle = title
      } else {
        this.current = this.leftypelist[0].id
        this.currentitle = this.leftypelist[0].title
      }
      this.getList(this.current)
      this.getHotlist(this.current)
    }
  },
  async mounted () {
    this.$root.getStatistics(YASF_INQUIRE)
  },
  methods: {
    getClose () {
      this.slide.show = false
    },
    async getList (id) {
      const res = await this.$get(`${api.doc.list}?appId=${this.appInfo.appId}&categoryId=${id}&pageSize=10000&type=5`, this)
      this.isloadend = true
      if (!res.response.success) {
        console.log(res.response.msg)
        return
      }
      if (res.data) {
        this.list = res.data.result
      } else {
        this.list = []
      }
      // this.getDetail(res.data.result[0].id)
    },
    async getDetail (id) {
      const res = await this.$get(`${api.doc.detail}&appId=${this.appInfo.appId}&id=${id}&htmlContent=`, this)
      if (!res.response.success) {
        console.log(res.response.msg)
        return
      }
      this.detail = res.data
      this.slide.show = true
    },
    setType (item) {
      $('.list-box').scrollTop(0, 1000) // eslint-disable-line
      this.current = item.id
      this.currentitle = item.title
      this.getList(item.id)
      this.getHotlist(item.id)
    },
    async getHotlist (id) {
      const res = await this.$get(`${api.doc.hotlist}?appId=${this.appInfo.appId}&categoryId=${id}&type=5`)
      if (res.data) {
        this.hotlist = res.data
      } else {
        this.hotlist = []
      }
    }
  },

}
</script>
<style lang="stylus">
.page-yasf
  .main-block
    flex 1
    overflow hidden
    padding 0.3rem 0.6rem
    display flex
    .left-nav
      width 3.2rem
      height 100%
      margin-right 0.4rem
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .item
        height 0.8rem
        line-height 0.8rem
        font-size 0.26rem
        color rgba(255, 255, 255, 0.9)
        padding 0 0.35rem
        background-color rgba(255, 255, 255, 0.2)
        border-radius 0.08rem
        border solid 1px rgba(255, 255, 255, 0.2)
        margin-bottom 0.05rem
        &.active
          background #f29530
    .right-con
      display flex
    .list-box
      width 9.8rem
      margin-right 0.2rem
      border-radius 0.1rem
      background #fff
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .emptyinfo
        width 100%
        height 100%
        display flex
        flex-direction column
        justify-content center
        align-items center
        color #666
      .list-title
        height 0.74rem
        border-radius 0.1rem 0.1rem 0 0
        font-size 0.24rem
        line-height 0.74rem
        background-color #fff
        padding 0 0.34rem
        border-bottom 1px solid #e5e5e5
        color #333333
      .item
        position relative
        background #fff
        padding 0.25rem 0.35rem
        box-sizing border-box
        display flex
        &:active
          background #f7f7f7
        &:after
          content ''
          position absolute
          bottom 0
          left 0.35rem
          right 0.35rem
          border-bottom 1px solid #e5e5e5
        &:last-child
          border-radius 0 0 0.1rem 0.1rem
        .imgs
          width 0.9rem
          height 0.9rem
          border-radius 50%
          margin-right 0.16rem
          background-color #edf3ff
          text-align center
          line-height 0.9rem
          flex-shrink 0
        .intro
          padding-right 0.3rem
          overflow hidden
          display flex
          flex-direction column
          justify-content center
          overflow hidden
          span
            color #ccc
            padding 0 0.1rem
        .title
          font-size 0.24rem
          color #333333
          line-height 1
          width 100%
          margin-bottom 0.2rem
        .desc
          font-size 0.18rem
          color #666666
          line-height 1
    .hotlist
      width 4.4rem
      box-sizing border-box
      background-color rgba(255, 255, 255, 0.2)
      border-radius 0.1rem
      border solid 1px rgba(255, 255, 255, 0.2)
      p
        padding 0.18rem
        color rgba(255, 255, 255, 0.6)
        font-size 0.2rem
      .prevtitle
        padding 0.3rem 0 0.2rem 0.18rem
        font-size 0.22rem
        color #fff
        font-weight 600
      .newsitem
        position relative
        display flex
        align-items center
        // margin 0 0.18rem
        padding 0.16rem 0.18rem
        &:after
          border-bottom 1px solid rgba(255, 255, 255, 0.2)
          content ''
          position absolute
          bottom 0
          left 0.18rem
          right 0.18rem
        &:active
          background rgba(255, 255, 255, 0.2)
        .num
          border 1px solid #fff
          border-radius 50%
          width 0.3rem
          height 0.3rem
          text-align center
          margin-right 0.15rem
          font-size 0.2rem
          color #fff
          flex-shrink 0
        .newstitle
          flex 1
          overflow hidden
          font-size 0.2rem
          line-height 0.3rem
          color #fff
  .slide-box
    .slide-box-content
      width 8rem
      padding 0 0.4rem
      .title
        font-size 0.36rem
        line-height 1.4
        font-weight 600
        padding 0.6rem 0 0.2rem 0
      .detail
        line-height 1.8
        font-size 0.22rem
        img
          max-width 100%
        p
          margin 1em 0 !important
          font-size 0.22rem !important
        .mpda_bottom_container
          h2:first-child
            display none
  .footerslide
    .btns
      width 8rem
</style>
